import React, { useState, useRef,useEffect } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import highcharts3d from 'highcharts/highcharts-3d'
import { formatUkNumber } from '../Utils';

highcharts3d(Highcharts)
export function DrawChart(props) {
    
    let series = props.series;
    
    let title = props.title;
    
    let chartType = props.chartType;
    
    if (!series || series.length === 0) {
        console.log("=======",series);
        return (<div>No records</div>);
    }

    //   const formattedSeries = {
    //     name: "Programs",
    //     data: props.series.data.map(item => ({
    //         name: item[0], // Extract category name
    //         y: item[1] // Extract value
    //     }))
    // };
    const options = {
        chart: {
            type: chartType,
            backgroundColor: 'rgba(0,0,0,0)',
            //backgroundColor: 'black',
            margin: [0,0,0,15],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            options3d: {
                enabled: true,
                alpha: 65
                // beta: 0
            }
        },
        title: {
            text: title
        },
        subtitle: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                // const formattedValue = Highcharts.numberFormat(this.y, 0, '.', ',');
                // return '<b>' + this.point.percentage.toFixed(1) + '% (' + formattedValue + ')</b>';
                return `<b>${this.point.percentage.toFixed(1)}% (${formatUkNumber(this.y)})</b>`;
            },
            pointFormat: '<b>{point.percentage:.1f}% ({point.y:,.0f})</b>'
        },
        plotOptions: {
            pie: {
                innerSize: 100,
                depth: 45,
                minPointSize :5,
                dataLabels: {
                    enabled: true,
                    backgroundColor: 'rgba(252, 255, 197, 0.7)',
                    // borderWidth: 1,
                    // borderColor: '#AAA',
                    // format: '<span><b>{point.name}</b>: {point.percentage:.1f}% ({point.y})</span>',
                    formatter: function () {
                        return `<span>
                            <b>${this.point.name}</b>: 
                            ${this.point.percentage.toFixed(1)}% 
                            (${formatUkNumber(this.y)})
                        </span>`;
                    },
                    style:{color:'#000',fontWeight:'noraml'}
                },
                colors: props.color,
            }
        },
        series: [series]
    }
    // console.log(options);
        return (<div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
        );
    }

    export function DrawChart1(props) {
    
        let series = props.series;
        let title = props.title;
        let chartType = props.chartType;
    
        // Fix: Ensure series exists and is formatted correctly
        if (!series || !series.data || series.data.length === 0) {
            console.log("No Data: ", series);
            return <div>No records</div>;
        }
    
        // Format series properly
        const formattedSeries = {
            name: "Programs",
            data: props.series.data.map(item => ({
                name: item[0], // Extract category name
                y: item[1] // Extract value
            }))
        };
    
        const options = {
            chart: {
                type: chartType,
                backgroundColor: 'rgba(0,0,0,0)',
                margin: [-110, 0, 120, 15],
                spacingTop: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0,
                options3d: {
                    enabled: true,
                    alpha: 65
                }
            },
            title: { text: title },
            subtitle: { text: '' },
            credits: { enabled: false },
            tooltip: {
                formatter: function () {
                    return `<b>${this.point.name}: ${this.point.percentage.toFixed(1)}% (${formatUkNumber(this.y)})</b>`;
                }
            },
            plotOptions: {
                pie: {
                    innerSize: 100,
                    depth: 45,
                    showInLegend: true,
                    dataLabels: {
                        enabled: false,
                        allowOverlap: true,
                        distance: 15, 
                        crop: false,  
                        overflow: "none",
                        softConnector: true, 
                        connectorColor: "#777", 
                        formatter: function () {
                            if (this.y < 10) {
                                return `<span style="font-size:12px;"><b>${this.point.name}</b>: ${this.y}</span>`;
                            }
                            return `<span style="font-size:14px;"><b>${this.point.name}</b>: ${this.y}</span>`;
                        },
                        style: { color: '#000', fontWeight: 'normal' }
                    }
                    ,
                    colors: props.color,
                    minPointSize: 1 // Ensure even small values show up
                }
            },    
            legend: {
                enabled: true,
                // itemWidth: 100,
                layout: 'horizontal', // Arrange items in a row
                align: 'center',
                verticalAlign: 'bottom',  
                floating: false,         
                itemMarginTop: 5,        
                labelFormatter: function () {
                    return `${this.name}: ${formatUkNumber(this.y)}`; // ✅ Shows name & value in legend
                }
            },        
            series: [formattedSeries]
        };
    
        return (
            <div>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        );
    }
    


    export function ChartIncludeColumn(props) {


        const category = props.category;
        const series = props.series;
        const colors = props.color;
        // console.log("IN CAHRT",props);

        // Attach correct color to each series
        const coloredSeries = series.map((s, idx) => ({
            ...s,
            color: colors[idx]   // <-- assign color per series
        }));

        const options = {
                chart: {
                    type: 'column',
                    options3d: {
                        enabled: true,
                        alpha: 2,
                        beta: 3,
                        viewDistance: 20,
                        depth: 40
                    }
                },
                credits: {
                    enabled: false
               },
                title: {
                    text: '',
                    align: 'left'
                },
                xAxis: {
                    categories: category,
                    labels: {
                        formatter: function() {
                            // Custom label formatter function
                            return this.value;
                          },
                        autoRotation: [-55,0],
                        skew3d: true,
                        style: {
                            textOverflow: 'none',
                            fontSize: '12px',
                            staggerLines: 2,
                        },
                        // rotation: -50,
                       
                    }
                },
            
                yAxis: {
                    allowDecimals: false,
                    min: 0,
                    title: {
                        text: '',
                        skew3d: true,
                        style: {
                            fontSize: '16px'
                        }
                    }
                },
            
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    formatter: function() {
                        const formattedValue = Highcharts.numberFormat(this.y, 0, '.', ',');
                        return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': ' + formattedValue;
                      }
                },
            
                plotOptions: {
                    column: {
                        
                        depth: 40
                    }
                },
            
                series: coloredSeries
            }
      //console.log(options);
            return (<div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </div>
            );
        }
    
export function ChartStackColumn(props) {
    const category = props.category;
    const series = props.series;
    // console.log("IN CAHRT",props);
    const options = {
            chart: {
                type: 'column',
                options3d: {
                    enabled: true,
                    alpha: 2,
                    beta: 3,
                    viewDistance: 20,
                    depth: 40
                }
            },
            credits: {
                enabled: false
            },
            title: {
                text: '',
                align: 'left'
            },
            xAxis: {
                categories: category,
                labels: {
                    skew3d: true,
                    style: {
                        fontSize: '16px'
                    }
                }
            },
        
            yAxis: {
                allowDecimals: false,
                min: 0,
                title: {
                    text: '',
                    skew3d: true,
                    style: {
                        fontSize: '16px'
                    }
                }
            },
        
            tooltip: {
                headerFormat: '<b>{point.key} - {point.stackTotal}</b><br>',
                pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: {point.y}'
            },
        
            plotOptions: {
                column: {
                    stacking: 'normal',
                    depth: 40
                }
            },
        
            series: series
        }
    //console.log(options);
        return (<div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
        );
    }
